import { useLocation } from 'react-router-dom';
import moment from "moment/moment";

// Custom Hook: useQueryParams
export const useQueryParams = () => {
    const location = useLocation();
    return new URLSearchParams(location.search);
}

// generate to vietnam's price
export const toVND = (price: number) => {
    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);
}

export const formatDate = (date: string, format = 'HH:mm:ss DD/MM/YYYY') => {
    if (!date) return '';
    return moment(new Date(date)).format(format);
}


export const formatExpiredAt = (value?: string | null): string => {
    if (!value) return "--";

    return new Intl.DateTimeFormat("vi-VN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    }).format(new Date(value));
}


export type ExpiryStatus = "success" | "warning" | "danger";

export const getExpiryStatus = (value?: string | null): ExpiryStatus => {
    if (!value) return "success";

    const expiredAt = new Date(value);
    if (Number.isNaN(expiredAt.getTime())) return "success";

    const diffMs = expiredAt.getTime() - Date.now();
    const remainingDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    if (remainingDays <= 3) return "danger";
    if (remainingDays <= 7) return "warning";

    return "success";
}

export const parseNumberValue = (value: unknown): number | undefined => {
    if (typeof value === "number" && Number.isFinite(value)) {
        return value;
    }

    if (typeof value === "string") {
        const numeric = Number(value);
        if (!Number.isNaN(numeric)) {
            return numeric;
        }
    }

    return undefined;
};

export const getCategoryMenuCount = (category: any): number | undefined => {
    if (!category || typeof category !== "object") {
        return undefined;
    }

    const candidateKeys = [
        "total_item",
        "totalItems",
        "total_items",
        "itemCount",
        "itemsCount",
        "menuCount",
        "menusCount",
        "menus_count",
    ];

    for (const key of candidateKeys) {
        const value = parseNumberValue((category as Record<string, any>)[key]);
        if (value !== undefined) {
            return value;
        }
    }

    if (Array.isArray((category as Record<string, any>).menus)) {
        return ((category as Record<string, any>).menus as unknown[]).length;
    }

    return undefined;
};

export const getOptionMenuCount = (option: any): number => {
    if (!option || typeof option !== "object") {
        return 0;
    }

    const candidateKeys = [
        "menus_count",
        "menu_count",
        "menusCount",
        "menuCount",
        "total_menus",
        "totalMenus",
    ];

    for (const key of candidateKeys) {
        const value = parseNumberValue((option as Record<string, any>)[key]);
        if (value !== undefined) {
            return value;
        }
    }

    if (Array.isArray((option as Record<string, any>).menus)) {
        return ((option as Record<string, any>).menus as unknown[]).length;
    }

    return 0;
};
